import { CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";
import {
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	Router,
	RouterModule,
	Routes
} from "@angular/router";
import { SpinnerService } from "@app/core/spinner/spinner.service";
import { AdminGuard } from "@app/guard/admin.guard";
import { LoginGuard } from "@app/guard/login.guard";
import { ClickarPath } from "@shared/clickar-constants";

const appRoutes: Routes = [
	{
		path: "*",
		loadChildren: () =>
			import("./core/core.module").then(m => m.CoreModule),
		canActivate: [],
		canActivateChild: []
	},
	{
		path: ClickarPath.ADMIN,
		loadChildren: () =>
			import("./admin/admin.module").then(m => m.AdminModule),
		canActivate: [LoginGuard, AdminGuard],
		canActivateChild: []
	},
	{
		path: ClickarPath.PRIVATE,
		loadChildren: () =>
			import("./private/private.module").then(m => m.PrivateModule),
		canActivate: [LoginGuard],
		canActivateChild: []
	}
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forRoot(appRoutes, {
			scrollPositionRestoration: 'enabled',
			useHash: false,
			onSameUrlNavigation: "reload",
			anchorScrolling: "enabled",
			bindToComponentInputs: true
		})
	],
	declarations: [],
	exports: [RouterModule],
	providers: [LoginGuard]
})
export class AppRouterModule {
	private router = inject(Router);
	private spinnerService = inject(SpinnerService);

	constructor() {
		this.router.events.subscribe(event => {
			/* if (!environment.production) {
				console.log(event);
			} */
			if (event instanceof NavigationStart) {
				this.spinnerService.show("Router START");
			} else if (
				event instanceof NavigationEnd ||
				event instanceof NavigationCancel ||
				event instanceof NavigationError
			) {
				this.spinnerService.hide("Router STOP");
			}
		});
	}
}